module.exports = __webpack_public_path__ + "static/media/room_manager_arrow.2f3f3bfe.svg";